import { Account } from '../types/account';

/**
 * Determines what color the worksheet variance is. For some account types, a positive variance can be good (green) or bad (red) and the same for a negative variance
 * @param worksheet
 * @returns
 */
export function getVarianceDirectionColor(account: Account): string {
    if (account!.variance < 0) {
        return account!.class === 'EXPENSE' || account!.class === 'LIABILITY'
            ? 'text-green-600 dark:text-green-500'
            : 'text-red-600 dark:text-red-500';
    } else {
        return account!.class !== 'EXPENSE' && account!.class !== 'LIABILITY'
            ? 'text-green-600 dark:text-green-500'
            : 'text-red-600 dark:text-red-500';
    }
}
